
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex';

export default defineComponent({
    name: "EasyImageSlider",
    props: {
        images: {
            type: Array,
            required: true
        },
        aspect: {
            type: String,
            default: 'aspect-3x2'
        }
    },
    setup(_props) {
        const store = useStore();

        const imageIndex = ref(0);

        const imageUrls = ref<Array<string>>(_props.images as Array<string>);

        const pageTexts = computed(() => store.getters["ApplicationModule/getPageTexts"]);

        const sliderWrapper = ref();

        const nextImage = () => {
            if (imageIndex.value - 1 < _props.images.length) imageIndex.value++;
            scrollImage();
        }

        const previousImage = () => {
            if (imageIndex.value > 0) imageIndex.value--;
            scrollImage();
        }

        const scrollImage = () => {
            const wrapper = sliderWrapper.value as HTMLElement;
            const scrollElement = wrapper.children[imageIndex.value];
            if (scrollElement)
                scrollElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }

        return {
            imageIndex,
            pageTexts,
            imageUrls,
            sliderWrapper,
            nextImage,
            previousImage
        }
    },
})
